import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { TitleWithIcon } from '@app/core';
import {
  ParticipantFieldCategory,
  useParticipantFieldsCategory,
} from '@app/api';

const useStyles = createUseStyles<string, {}, any>((theme: Theme) => ({
  descriptionContainer: {
    background: theme.colors.grayBackground,
    padding: theme.marginBase * 2,
    borderRadius: theme.borderRadius.std,
  },
  description: {
    ...theme.fonts.caption,
  },
}));

interface Props {
  category: ParticipantFieldCategory;
  children?: React.ReactNode;
  noDesc?: boolean;
}

export const ProfileCategorySection = ({
  category,
  children,
  noDesc,
}: Props) => {
  const classes = useStyles();

  const categoryInfo = useParticipantFieldsCategory(category);

  if (!categoryInfo) {
    return <section>{children}</section>;
  }

  return (
    <section>
      <TitleWithIcon
        title={categoryInfo.title}
        icon={categoryInfo.icon}
        iconColor={categoryInfo.iconColor}
      />
      {categoryInfo.description && !noDesc && (
        <div className={classes.descriptionContainer}>
          <p className={classes.description}>{categoryInfo.description}</p>
        </div>
      )}
      {children}
    </section>
  );
};
